import script from "./messageText.vue?vue&type=script&setup=true&lang=js"
export * from "./messageText.vue?vue&type=script&setup=true&lang=js"

import "./messageText.vue?vue&type=style&index=0&id=427e73a1&scoped=true&lang=css"

import exportComponent from "D:\\Jawsro\\company\\虎鲸\\v3\\hujing_pro_h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-427e73a1"]])

export default __exports__